import { useChatStore } from '@/chat/hooks/use-chat-store';
import {
  Conversation,
  ConversationContent,
  ConversationEmptyState,
  ConversationScrollButton,
} from '@/components/ai-elements/conversation';
import { GenerationInfoSheet } from '@/music/components/generation-info-sheet';
import { PlayerBar } from '@/music/components/player-bar';
import { Composer } from './composer';
import { MessageBubble } from './message-bubble';
import { PlayerBarScrollSync } from './player-bar-scroll-sync';

export const ChatView = () => {
  const messages = useChatStore((state) => state.messages);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Conversation>
        <ConversationContent
          className={`mx-auto w-full max-w-3xl ${messages.length === 0 ? 'h-full' : ''}`}
        >
          {messages.length === 0 ? (
            <ConversationEmptyState>
              <h1 className="text-lg font-semibold text-gray-900">AI 음악 큐레이션</h1>
              <p className="text-muted-foreground text-sm">
                장면이나 분위기를 알려주시면 어울리는 음악을 찾아드려요
              </p>
              <p className="text-muted-foreground text-xs">
                이미지, 영상, 음원(최대 100MB, 영상 3분 이하)을 첨부하면 더 정확하게 추천해 드려요
              </p>
            </ConversationEmptyState>
          ) : (
            messages.map((message) => <MessageBubble key={message.id} message={message} />)
          )}
        </ConversationContent>
        <ConversationScrollButton />
        <PlayerBarScrollSync />
      </Conversation>
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-3 px-4 pb-6">
        <PlayerBar />
        <Composer />
      </div>
      <GenerationInfoSheet />
    </div>
  );
};
